import { createAction } from '@reduxjs/toolkit';
import { notAvailable } from 'core/common/constants';
import { normalizeError } from 'core/common/errors';
import {
  ATTRS_ANALYTICS_FLOW_NAME,
  ATTRS_ANALYTICS_FUNNEL_LOCALE,
  ATTRS_ANALYTICS_FUNNEL_NAME,
  SpanName,
} from 'core/common/observability/entities';
import { AppThunk } from 'core/common/store';
import { UserLocation } from '../../entities';

export const fetchUserLocationPending = createAction('userLocation/FETCH_USER_LOCATION/pending');
export const fetchUserLocationSucceed = createAction<UserLocation>(
  'userLocation/FETCH_USER_LOCATION/succeed',
);
export const fetchUserLocationFailed = createAction('userLocation/FETCH_USER_LOCATION/failed');

export const fetchUserLocationRequest = (): AppThunk => async (dispatch, _, context) => {
  const {
    locationService,
    loggingService,
    funnelSettingsService,
    errorMonitoringService,
    observabilitySystem,
  } = context;

  const cookieLocation = locationService.readCookieLocation();

  if (cookieLocation) {
    dispatch(fetchUserLocationSucceed(cookieLocation));
    return;
  }

  dispatch(fetchUserLocationPending());

  const spanAttributes = {
    [ATTRS_ANALYTICS_FUNNEL_NAME]: funnelSettingsService.getFunnelName(),
    [ATTRS_ANALYTICS_FLOW_NAME]: funnelSettingsService.getFlowName(),
    [ATTRS_ANALYTICS_FUNNEL_LOCALE]: funnelSettingsService.getFunnelLocale(),
  };

  const span = observabilitySystem.startSpan(SpanName.USER_LOCATION_REQUEST);
  span.setAttributes(spanAttributes);

  try {
    const userLocation = await locationService.getLocation();

    dispatch(fetchUserLocationSucceed(userLocation));
    span.succeed();
  } catch (e) {
    const err = normalizeError(e);
    loggingService.error(err);

    dispatch(fetchUserLocationFailed());
    span.fail(err);

    errorMonitoringService.captureError(err, {
      tags: {
        get_params: location.search || notAvailable,
        error_message: err.message,
        error_reason: 'user_location_request',
        funnel_name: funnelSettingsService.getFunnelName(),
      },
    });
  }
};

export const updateUserLocation = createAction<UserLocation>('userLocation/UPDATE_USER_LOCATION');
